<template>
    <div class="grain" v-show="grainLoaded">
        <div class="grain__bg">
        </div>
        <div class="grain__mask" ref="mask" v-if="!isMobile">
            <div class="grain__mask__wrapper">
                <div class="grain__mask__inner" ref="maskInner"></div>
            </div>
        </div>
    </div>
</template>

<script>

import Cursor from '@/utils/Cursor'
import EventHub from '@/utils/EventHub'

import grainImg from '../assets/images/noise3.png'

export default {
    name: 'AppGrainBg',

    data() {
        return {
            isMobile: false,
            grainLoaded: false
        }
    },

    created()
    {

    },

    mounted()
    {
        this.mouse = new Cursor()
        this.addEventListeners()

        const img = new Image()

        img.onload = () => {
            this.grainLoaded = true
        }

        img.src = grainImg
    },

    destroyed()
    {
        this.removeEventListeners()
        this.mouse.destroy()
    },

    methods: {
        addEventListeners()
        {
            EventHub.$on('application:on-tick', this.onTick)
            EventHub.$on('window:resize', this.onResize)
        },

        removeEventListeners()
        {
            EventHub.$off('application:on-tick', this.onTick)
            EventHub.$off('window:resize', this.onResize)
        },

        getRandomInt(min, max)
        {
            return Math.floor(Math.random() * (max - min + 1)) + min
        },

        onTick()
        {
            if(!this.isMobile)
            {
                const randY = this.getRandomInt(-30, 30)
                const randX = this.getRandomInt(-30, 30)
                this.$refs.maskInner.style.transform = `translate3d(${randX}%, ${randY}%, 0)`
                this.$refs.mask.style.transform = `translate3d(${this.mouse.x - 350}px, ${this.mouse.y - 350}px, 0)`
            }
        },

        onResize(windowObj)
        {
            if(windowObj.width <= 768)
            {
                this.isMobile = true
            }
            else
            {
                this.isMobile = false
            }
        }
    }
}
</script>

<style lang="stylus">

.grain
    z-index 2
    cursor pointer
    position fixed
    left -100%
    top -100%
    height 300%
    width 300%
    // clip-path circle(150px at 50% 50%)
    // background red

.grain__bg
    width 100%
    height 100%
    background url('../assets/images/noise3.png')
    opacity 0.25
    animation-duration 4s
    animation-timing-function steps(10, end)
    animation-name grain
    animation-iteration-count infinite

.grain__mask
    cursor pointer
    // overflow hidden
    position absolute
    top 33.33%
    left 33.33%
    width 700px
    height 700px
    background $grey
    border-radius 50%
    opacity 0.7
    mask-image radial-gradient(ellipse 50% 50% at 50% 50%, black 30%, transparent 100%)
    // transform translate3d(1500px, 1500px, 0)

.grain__mask__wrapper
    position absolute
    height 300%
    width 300%
    left -100%
    top -100%
    // background red

.grain__mask__inner
    position relative
    display block
    width 100%
    height 100%
    background url('../assets/images/noise3.png')
    // background red
    // animation-duration 10s
    // animation-timing-function steps(10, end)
    // animation-name grain
    // animation-iteration-count infinite
    // animation: grain 8s steps(10) infinite;

    
@keyframes grain {
    0%, 100%
    {
        transform:translate(0,0)
    }
    10%
    {
        transform:translate(-5%, -10%)
    }
    20%
    {
        transform:translate(-15%, 5%)
    }
    30%
    {
        transform:translate(7%, -25%)
    }
    40%
    {
        transform:translate(21%, -25%)
    }
    50%
    {
        transform:translate(-25%, 10%)
    }
    60%
    {
        transform:translate(15%, 0%)
    }
    70%
    {
        transform:translate(0%, 15%)
    }
    80%
    {
        transform:translate(25%, 35%)
    }
    90%
    {
        transform:translate(-10%, 10%)
    }
}   

</style>